module.exports = __webpack_public_path__ + "static/img/1_1_1.1b77b314.jpg";